import { faCrown } from '@fortawesome/free-solid-svg-icons';

import { Cta } from 'apps/dashboard/shared/scripts/components';

import { upgradeCardClassName } from './styles';

interface Props {
  cardId: string;
}

const UpgradeCard = ({ cardId }: Props) => {
  return (
    <Cta
      className={upgradeCardClassName}
      faIcon={faCrown}
      to={`/dashboard/cards/${cardId}/upgrade`}
      link
      mobile
    >
      Upgrade
    </Cta>
  );
};

UpgradeCard.displayName = 'UpgradeCard';

export default UpgradeCard;
